import type { ReactNode } from "react";
import { Button, Group, Modal, Text } from "@mantine/core";

interface ConfirmModalProps {
  opened: boolean;
  onClose: () => void;
  onConfirm: () => void;
  isPending: boolean;
  title: string;
  confirmLabel: string;
  children: ReactNode;
}

export function ConfirmModal({
  opened,
  onClose,
  onConfirm,
  isPending,
  title,
  confirmLabel,
  children,
}: ConfirmModalProps) {
  return (
    <Modal
      opened={opened}
      onClose={onClose}
      title={
        <Text fw={600} fz="lg" c="primary.6">
          {title}
        </Text>
      }
      centered
      radius="lg"
      size={480}
    >
      <Text component="div" c="dimmed" fz="sm" mb="xl">
        {children}
      </Text>
      <Group justify="flex-end" gap="sm">
        <Button variant="subtle" color="gray" onClick={onClose} disabled={isPending}>
          Cancel
        </Button>
        <Button color="primary" loading={isPending} onClick={onConfirm}>
          {confirmLabel}
        </Button>
      </Group>
    </Modal>
  );
}
